module.exports = __webpack_public_path__ + "media/images/no-image-thumb-6ff9b172a6e26df220bf7f5c53769699.jpg";